import React from 'react';
import {Outlet} from 'react-router-dom';
import useAuthStore from '../store/authStore';

const PublicRoutes = () => {
  const {user: userData, token: isLogin} = useAuthStore();
  const search = window.location.search || '';

  if (isLogin && userData?.user_role === 'SUPERADMIN') {
    window.location.replace('/super-admin/dashboard' + search);
  }
  if (isLogin && userData?.user_role === 'ADMIN') {
    window.location.replace('/admin-dashboard' + search);
  }
  if (isLogin && userData?.user_role === 'LEADER') {
    if (!userData?.address) {
      window.location.replace('/profile-step-1' + search);
    } else if (!userData?.experience) {
      window.location.replace('/journey/1' + search);
    } else {
      window.location.replace('/leader' + search);
    }
  }
  if (isLogin && userData?.user_role === 'DISCIPLE') {
    if (!userData.is_impersonate) {
      if (!userData?.address) {
        window.location.replace('/profile-step-1' + search);
      } else if (!userData?.experience) {
        window.location.replace('/journey/1' + search);
      } else {
        window.location.replace('/disciple' + search);
      }
    } else {
      window.location.replace('/disciple' + search);
    }
  }
  return <Outlet />;
};

export default PublicRoutes;
